export default __webpack_public_path__ + "static/bed-bath-beyond-4-b-f59456cf1532d4da282f2f5ac08a4793.gif";